import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/config.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config set <key>=<value> [<key>=<value> ...]
npm config get [<key> [<key> ...]]
npm config delete <key> [<key> ...]
npm config list [--json]
npm config edit

alias: c
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/config.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`npm gets its config settings from the command line, environment
variables, `}<inlineCode parentName="p">{`npmrc`}</inlineCode>{` files, and in some cases, the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/npmrc"
      }}>{`npmrc`}</a>{` for more information about the npmrc
files.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/config"
      }}>{`config(7)`}</a>{` for a more thorough explanation of the
mechanisms involved, and a full list of config options available.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`npm config`}</inlineCode>{` command can be used to update and edit the contents
of the user and global npmrc files.`}</p>
    <h3>{`Sub-commands`}</h3>
    <p>{`Config supports the following sub-commands:`}</p>
    <h4>{`set`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config set key=value [key=value...]
npm set key=value [key=value...]
`}</code></pre>
    <p>{`Sets each of the config keys to the value provided.`}</p>
    <p>{`If value is omitted, then it sets it to an empty string.`}</p>
    <p>{`Note: for backwards compatibility, `}<inlineCode parentName="p">{`npm config set key value`}</inlineCode>{` is supported
as an alias for `}<inlineCode parentName="p">{`npm config set key=value`}</inlineCode>{`.`}</p>
    <h4>{`get`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config get [key ...]
npm get [key ...]
`}</code></pre>
    <p>{`Echo the config value(s) to stdout.`}</p>
    <p>{`If multiple keys are provided, then the values will be prefixed with the
key names.`}</p>
    <p>{`If no keys are provided, then this command behaves the same as `}<inlineCode parentName="p">{`npm config
list`}</inlineCode>{`.`}</p>
    <h4>{`list`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config list
`}</code></pre>
    <p>{`Show all the config settings. Use `}<inlineCode parentName="p">{`-l`}</inlineCode>{` to also show defaults. Use `}<inlineCode parentName="p">{`--json`}</inlineCode>{`
to show the settings in json format.`}</p>
    <h4>{`delete`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config delete key [key ...]
`}</code></pre>
    <p>{`Deletes the specified keys from all configuration files.`}</p>
    <h4>{`edit`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm config edit
`}</code></pre>
    <p>{`Opens the config file in an editor.  Use the `}<inlineCode parentName="p">{`--global`}</inlineCode>{` flag to edit the
global config.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`editor`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: The EDITOR or VISUAL environment variables, or 'notepad.exe' on
Windows, or 'vim' on Unix systems`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`The command to run for `}<inlineCode parentName="p">{`npm edit`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm config edit`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`location`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "user" unless `}<inlineCode parentName="li">{`--global`}</inlineCode>{` is passed, which will also set this value
to "global"`}</li>
      <li parentName="ul">{`Type: "global", "user", or "project"`}</li>
    </ul>
    <p>{`When passed to `}<inlineCode parentName="p">{`npm config`}</inlineCode>{` this refers to which config file to use.`}</p>
    <p>{`When set to "global" mode, packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{` folder
instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`long`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Show extended information in `}<inlineCode parentName="p">{`ls`}</inlineCode>{`, `}<inlineCode parentName="p">{`search`}</inlineCode>{`, and `}<inlineCode parentName="p">{`help-search`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm"
        }}>{`npm`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      